import { render, staticRenderFns } from "./addorupdate.vue?vue&type=template&id=d22b4716"
import script from "./addorupdate.vue?vue&type=script&lang=js"
export * from "./addorupdate.vue?vue&type=script&lang=js"
import style0 from "./addorupdate.vue?vue&type=style&index=0&id=d22b4716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports